export const SET_DATA = 'profileExitInterview/SET_DATA'
export const SET_DOCUMENTS = 'profileExitInterview/SET_DOCUMENTS'
export const SET_IS_FETCHING = 'profileExitInterview/SET_IS_FETCHING'
export const SET_COMMENTS = 'profileExitInterview/SET_COMMENTS'
export const SET_USER = 'profileExitInterview/SET_USER'
export const RESET_DATA = 'profileExitInterview/RESET_DATA'
